var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import crypto from 'crypto-js';
import URI from 'urijs';
import jwt_decode from 'jwt-decode';
import * as yup from 'yup';
import { User } from './User';
import log from 'loglevel';
var CALLBACK_PARAMS_SCHEMA = yup.object().shape({
    session_state: yup.string(),
    id_token: yup.string(),
    access_token: yup.string(),
    token_type: yup.string(),
    expires_in: yup.number(),
});
var STORAGE_KEY = 'xbpm-runtime';
var OIDC = /** @class */ (function () {
    function OIDC(config) {
        this.config = config;
    }
    /**
     * generates random disposable key
     * @returns
     */
    OIDC.prototype._generateNonce = function () {
        log.debug("Auth: Generating nonce");
        return crypto.lib.WordArray.random(16).toString();
    };
    /**
     * get keycloak url path
     * @returns keycloak oauth url for redirect
     */
    OIDC.prototype.getOAuthPath = function () {
        var _a = this.config, authority = _a.authority, client_id = _a.client_id, redirect_uri = _a.redirect_uri, response_type = _a.response_type, scope = _a.scope;
        var nonce = this._generateNonce();
        var params = {
            authority: authority,
            client_id: client_id,
            redirect_uri: redirect_uri,
            response_type: response_type,
            scope: scope,
            nonce: nonce,
        };
        // there could be some difference between how do we get path, but in fact that url is documented
        var keyCloakUrl = new URI(authority + "/protocol/openid-connect/auth").addQuery(params);
        return keyCloakUrl.valueOf();
    };
    OIDC.prototype._getLogoutPath = function (redirect_uri) {
        if (redirect_uri === void 0) { redirect_uri = null; }
        var _a = this.config, authority = _a.authority, post_logout_redirect_uri = _a.post_logout_redirect_uri;
        redirect_uri = redirect_uri || post_logout_redirect_uri;
        var keyCloakUrl = new URI(authority + "/protocol/openid-connect/logout").addQuery('redirect_uri', redirect_uri);
        return keyCloakUrl.valueOf();
    };
    OIDC.prototype.clearStorage = function () {
        log.debug('Auth: Clearing storage');
        localStorage.removeItem(STORAGE_KEY);
    };
    OIDC.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, userData, user;
            return __generator(this, function (_a) {
                data = localStorage.getItem(STORAGE_KEY);
                if (!data)
                    return [2 /*return*/, null];
                userData = JSON.parse(data);
                log.debug("Auth: User is " + data);
                user = new User(userData);
                return [2 /*return*/, user];
            });
        });
    };
    OIDC.prototype.signoutRedirect = function (redirect_uri) {
        if (redirect_uri === void 0) { redirect_uri = null; }
        this.clearStorage();
        var url = this._getLogoutPath(redirect_uri);
        log.debug("Auth: Configured logout url " + url);
        window.location.href = url;
    };
    OIDC.prototype.signinRedirect = function () {
        this.clearStorage();
        var keyCloakUrl = this.getOAuthPath();
        log.debug("Auth: Configured OAuth url " + keyCloakUrl);
        window.location.href = keyCloakUrl;
    };
    OIDC.prototype.signinRedirectCallback = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var params, profile, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = url || window.location.href;
                        params = new URI(url.replace('#', '?')).query(true);
                        if (!params.expires_in)
                            throw new Error("Token expires_in doesn't provided in callback params!");
                        // type converting (uri returns everything as string)
                        params = __assign(__assign({}, params), { expires_in: parseInt(params.expires_in) });
                        profile = jwt_decode(params.access_token);
                        // validate url params
                        return [4 /*yield*/, CALLBACK_PARAMS_SCHEMA.isValid(params)];
                    case 1:
                        // validate url params
                        _a.sent();
                        params = __assign(__assign({}, params), { profile: profile });
                        localStorage.setItem(STORAGE_KEY, JSON.stringify(params));
                        log.debug("Auth: CallBack params " + params);
                        return [2 /*return*/, new User(params)];
                    case 2:
                        err_1 = _a.sent();
                        throw new Error(err_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return OIDC;
}());
export { OIDC };
//# sourceMappingURL=OIDC.js.map